import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
export const API = `${BACKEND_URL.replace(/\/$/, '')}/api`;

const api = axios.create({ baseURL: API, timeout: 15000 });

export const listProperties = (params = {}) => api.get('/properties', { params }).then((r) => r.data);
export const getProperty = (id) => api.get(`/properties/${id}`).then((r) => r.data);
export const listNewLaunches = () => api.get('/new-launches').then((r) => r.data.items);
export const listCities = () => api.get('/cities').then((r) => r.data.items);
export const listDevelopers = () => api.get('/developers').then((r) => r.data.items);
export const listInspectionPlans = () => api.get('/inspection-plans').then((r) => r.data.items);
export const getConfigCounts = (listing_type = 'resale') => api.get('/config-counts', { params: { listing_type } }).then((r) => r.data.items);
export const createInterest = (payload) => api.post('/interests', payload).then((r) => r.data);

export default api;
